export default {
  'Text': 'Texte',
  'Styles': 'Styles',
  'Text here': 'Texte ici',
  'Add subtitles': 'Ajouter des sous-titres',
  'Text Color': 'Couleur du texte',
  'Outline': 'Contour',
  'Background': 'Fond',
  'Position': 'Position',
}